import { Base } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

/**
 * Slider
 */
export default class Slider extends Base {
  /**
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Slider',
    debug: false,
  };

  /**
   * Mount Slider
   * @returns {void}
   */
  mounted() {
    const { slug } = this.$el.dataset;
    this.swiper = new Swiper(`#${this.$el.id}`, {
      modules: [Navigation, Pagination],
      slidesPerView: 'auto',
      spaceBetween: 10,
      pagination: {
        el: `#progress-${slug}`,
        type: 'progressbar',
      },
      navigation: {
        nextEl: `#next-${slug}`,
        prevEl: `#prev-${slug}`,
      },
      centerSlides: true,
      breakpoints: {
        480: {
          spaceBetween: 30,
          centerSlides: false,
        },
      },
    });
  }
}
